import React, { useState } from 'react';
import { Box, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import i18n from '../locales/config';
import { useMutation } from 'react-query';
import { updateUserLanguage } from '../utils/api';
import useStore from '../Store/Store';
const LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ar', label: 'عربي', dir: 'rtl' },
];
const useUpdateLanguage = () => {
  return useMutation({
    mutationFn: updateUserLanguage,
    onSuccess: (data) => {
      console.log('Language updated successfully:', data);
    },
    onError: (error) => {
      console.error('Error updating language:', error);
    },
  });
};
const LanguageSelector = ({ variant = 'dropdown', position = 'top-right', style = {} }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { mutate: mutateLanguage } = useUpdateLanguage();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const { user } = useStore();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (langCode, event) => {
    event.stopPropagation();

    // Update UI immediately
    i18n.changeLanguage(langCode);
    localStorage.setItem('languageCode', langCode);
    setAnchorEl(null);

    const dir = getCurrentLanguage().dir;
    document.body.dir = dir;
    document.body.style.direction = dir;
    document.body.style.textAlign = dir === 'rtl' ? 'right' : 'left';

    const sidebarElement = document.querySelector('.flex-column-a');
    if (sidebarElement) {
      if (dir === 'rtl') {
        sidebarElement.classList.add('rtl');
      } else {
        sidebarElement.classList.remove('rtl');
      }
    }

    // Call backend API via React Query
    mutateLanguage({ userId: user._id, languageCode: langCode });
  };
  const getCurrentLanguage = () => {
    // 1️⃣ Try localStorage first
    const savedLang = localStorage.getItem('languageCode');

    const userLang = user?.languageCode;
    const currentLang = savedLang || userLang || i18n.language || 'en';

    const langConfig = LANGUAGES.find((lang) => lang.code === currentLang) || {
      code: 'en',
      label: 'English',
      dir: 'ltr',
    };

    return {
      label: langConfig.label,
      dir: langConfig.dir,
    };
  };

  if (variant === 'button') {
    return (
      <Box
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 12px',
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          border: '1px solid #e0e0e0',
          cursor: 'pointer',
          position: 'relative',
          ...style,
        }}
      >
        <LanguageIcon style={{ width: '16px', height: '16px', color: '#666' }} />
        <span style={{ fontSize: '14px', color: '#333', direction: getCurrentLanguage().dir }}>
          {getCurrentLanguage().label}
        </span>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  left: -5,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            },
          }}
          transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          style={{ marginLeft: '8px' }}
        >
          {LANGUAGES.map((lang) => (
            <MenuItem
              key={lang.code}
              onClick={(event) => handleLanguageChange(lang.code, event)}
              selected={i18n.language === lang.code}
              style={{ minWidth: '120px' }}
            >
              {lang.label}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  // Default dropdown variant
  return (
    <Box
      onClick={handleClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 8px',
        backgroundColor: 'transparent',
        borderRadius: '4px',
        cursor: 'pointer',
        position: 'relative',
        ...style,
      }}
    >
      <LanguageIcon style={{ width: '18px', height: '18px', color: '#666' }} />
      <span style={{ fontSize: '14px', color: '#333', direction: getCurrentLanguage().dir }}>
        {getCurrentLanguage().label}
      </span>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: -5,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        style={{ marginLeft: '8px' }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={(event) => handleLanguageChange(lang.code, event)}
            selected={i18n.language === lang.code}
            style={{ minWidth: '120px' }}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
